let _ = require('lodash');
window.$ = window.jQuery = require('jquery');
$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});


require('slick-carousel')
require('sweetalert')
require('./sliders')
require('./contact')
require('./work')


const header = document.getElementById('header'),
  sepHeader = document.getElementById('separatorHeader')
  if (header) {
    let heightHeader = header.offsetHeight
    sepHeader.style.height = heightHeader.toString() + 'px'
  }

/*===== MENU SHOW & HIDDEN =====*/
const navMenu = document.getElementById('nav-menu'),
  toggleMenu = document.getElementById('nav-toggle'),
  closeMenu = document.getElementById('nav-close')
  
  /*SHOW*/
  toggleMenu.addEventListener('click', ()=>{
    navMenu.classList.toggle('show')
  })
  
  /*HIDDEN*/
  closeMenu.addEventListener('click', ()=>{
    navMenu.classList.remove('show')
  })

//ANIMATIONS
const sr = ScrollReveal({
  distance: '30px',
  duration: 1000,
  delay: 300,
  //reset: true
})

sr.reveal(`.aboutHome img` , {origin: 'right'})
sr.reveal(`.floatDesk` , {origin: 'right'})
sr.reveal(`.about .pt1 img` , {origin: 'right'})
sr.reveal(`.about .pt2 img` , {origin: 'left'})
sr.reveal(`.itemServices .servLeft img` , {origin: 'left'})
sr.reveal(`.itemServices .servRight img` , {origin: 'right'})
sr.reveal(`.contact .container img` , {origin: 'right'})
sr.reveal(`footer picture` , {origin: 'bottom'})
sr.reveal(`.servicesHome .itemList div` , {origin: 'left', interval: 100})